import { MessageInbox } from "@/common/components/MessageInbox";

export function DashboardMessages() {
  return (
    <div className="w-full h-full bg-white p-6 rounded-lg">
      <MessageInbox />
    </div>
  );
}
